import { FC } from 'react'
import styles from './OrderHistoryItem.module.css'
import { Order } from '../../../__generated__/types'
import { formatAddress } from '../../../utils/formatAddress'
import { useCity } from '../../../context/CityContext'

interface Props {
    order: Order
}

enum TimeOfDay {
    morning = 'Утром',
    afternoon = 'Днём',
    evening = 'Вечером',
    night = 'Ночью'
}

const months = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря'
]

const STATUS_LABEL: Record<string, string> = {
    '0': 'Черновик',
    '1': 'Создан',
    '2': 'Водитель назначен',
    '3': 'Перераспределение',
    '4': 'Отменён',
    '5': 'В пути',
    '6': 'Завершён',
    '7': 'Еду к клиенту',
    '8': 'Машина ожидает'
}

function takeTimeOfDay(time?: string): string {
    if (!time) return ''
    const h = Number(time.slice(0, 2))
    if (h > 5 && h < 11) return TimeOfDay.morning
    if (h >= 11 && h < 17) return TimeOfDay.afternoon
    if (h >= 17 && h < 22) return TimeOfDay.evening
    return TimeOfDay.night
}

export const OrdersHistoryItem: FC<Props> = ({ order }) => {
    const { selectedCity } = useCity()
    const selected = {
        cityId: selectedCity?.id ?? null,
        countryName: selectedCity?.countryName ?? null
    }

    const dt = order.dateTime ?? order.createdAt
    const time = dt?.time

    const getDate = () => {
        if (!dt?.date) return ''
        const parts = dt.date.split('-').map(Number) // [year, month, day]
        if (parts.length < 3) return dt.date
        const now = new Date()
        if (
            parts[2] === now.getDate() &&
            parts[1] === now.getMonth() + 1 &&
            parts[0] === now.getFullYear()
        ) {
            return 'Сегодня'
        }
        return `${parts[2]} ${months[parts[1] - 1]}`
    }

    const from = order.points?.[0]
    const to = order.points?.[order.points.length - 1]

    return (
        <article className={styles.wrapper}>
            {dt && (
                <h4 className={styles.title}>
                    {getDate()}
                    {time ? `. ${takeTimeOfDay(time)}, в ${time}` : ''}
                </h4>
            )}

            <p className={styles.text}>
                {order.price} ₽,{' '}
                {from ? formatAddress(from, selected) : '—'} →{' '}
                {to ? formatAddress(to, selected) : '—'}
            </p>

            <div className={styles.footer}>
                <div className={styles.status}>
                    <span className={styles.status__title}>Статус: </span>
                    <span>
                        {STATUS_LABEL[order.status] ??
                            `Статус ${order.status}`}
                    </span>
                </div>
                <div className={styles.paid}>
                    <span>{order.paid ? 'Оплачен' : 'Не оплачен'}</span>
                </div>
            </div>
        </article>
    )
}
